import { ReactNode } from 'react'
import styled from 'styled-components'

import { media } from 'styles/media'

import { ParagraphSm } from '../../components/display/Typography'

const Heading = styled.h5`
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-md']?.['font-size']?.value};
  font-weight: ${({ theme }) =>
    theme?.['-ds-font-size-md']?.['font-weight']?.value};
  line-height: 1.3;
  margin-bottom: 8px;

  ${media.md`
    font-size: ${({ theme }) =>
      theme?.['-ds-font-size-xl']?.['font-size']?.value};
  font-weight: ${({ theme }) =>
    theme?.['-ds-font-size-xl']?.['font-weight']?.value};
  `}
`

const Outer = styled.div<{ centered?: boolean }>`
  flex-shrink: 0;
  flex-grow: 0;
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  width: 100%;
  margin-bottom: 22px;
  text-align: left;

  ${media.lg<{ centered?: boolean }>`
    text-align: ${({ centered }) => (centered ? 'center' : 'left')};
  `}

  svg {
    width: 48px;
    height: 48px;
    margin-bottom: 8px;

    ${media.md`
      width: 64px;
      height: 64px;
      margin-bottom: 32px;
    `}
  }
`

type Props = {
  icon: ReactNode
  heading: ReactNode
  text: ReactNode
  centered?: boolean
}

const IllustratedParagraph = ({ icon, heading, text, centered }: Props) => {
  return (
    <Outer centered={centered}>
      {icon || <svg />}

      <Heading>{heading}</Heading>

      <ParagraphSm>{text}</ParagraphSm>
    </Outer>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  text-align: left;
  width: 100%;
  max-width: 1300px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 34px;

  ${media.md`
    & > * {
      width: 50%;
      padding: 0 24px;
    }
  `}

  ${media.lg`
    margin-top: 48px;
    justify-content: center;

    & > * {
      width: 33.3%;
    }
  `}
`

export { IllustratedParagraph, Wrapper }
